import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import html2canvas from "html2canvas";
import Footer from "@/components/Marketplace/Footer";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import Image from "next/image";
import Slider from "react-slick";
import ChartComponent from "../../sections/build/components/ChartComponent";
import Header from "@/components/Marketplace/headerMarketplace";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { API_URL } from "@/config";
import { useDarkTheme } from "@/contexts/DarkTheme";
import {
  DP02,
  DP22,
  formatDate,
  formatEpochDate,
  formatMoney,
  formatToDecimalPlaces,
  getIsFxStrategy,
  getNameInitals,
  getValidSymbolImgUrl,
  minFixedDecimal,
  randomString,
  toNumberOrNull,
  useToastHelper,
} from "@/helpers/helperFunctions";
import { AccentColor } from "@/helpers/types";
import { cn } from "@/lib/utils";
import axios from "axios";
import {
  Chart,
  Filler,
  LineElement,
  PointElement,
  RadarController,
  RadialLinearScale,
} from "chart.js";
import { BadgeAlert, BadgeCheck, Eye } from "lucide-react";
import { GetServerSideProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import {
  CartesianGrid,
  Line,
  LineChart,
  PolarAngleAxis,
  PolarGrid,
  Radar,
  RadarChart,
  XAxis,
  YAxis,
} from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";
import { ContentType as TooltipContentType } from "recharts/types/component/Tooltip";
import Layout from "../../components/Layouts/Layout";
import Meta from "../../components/Layouts/Meta";
import Loader from "../../components/Loader";
import { Pagination } from "../../helpers/helperFunctions";
import ViewModal from "../../sections/build/components/StrategyViewModal";
import MonthlyStrategyPerformance from "@/sections/build/components/MonthlyStrategyPerformance";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useUserContext } from "@/contexts/userContext";
import { CURRENT_BROKER_NAME } from "@/config/logos";

Chart.register(
  LineElement,
  RadarController,
  Filler,
  PointElement,
  RadialLinearScale
);

type chartProps = {
  label: number[];
  values: any[];
  borderColor: string;
  title: string;
};

const formatUrl = (url: string) =>
  url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;

const Profile: React.FC = () => {
  const router = useRouter();
  const { t } = useTranslation("leaderboard");
  const [twitter, setTwitter] = useState(String);
  const [linkedin, setLinkedin] = useState(String);
  const [userInfo, setUserInfo] = useState<any>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const { user } = useUserContext();
  const [symbolsData, setSymbolsData] = useState<any>([]);
  const [performance, setPerformance] = useState<any>([]);
  const [profileData, setProfileData] = useState<any>({});
  const strategiesPerPage = useMemo(() => 6, []);
  const [logos, setLogos] = useState<any>(new Map());
  const [createdListDataItems, setCreatedListDataItems] = useState<any>([]);
  const [userLoading, setUserLoading] = useState<any>(true);
  const [exportLoader, setExportLoader] = useState<any>(false);
  const [createdTotalCount, setCreatedTotalCount] = useState(0);
  const [createdOffset, setCreatedOffset] = useState(0);
  const [last30Data, setLast30Data] = useState([]);

  const [currentCreatedPage, setCurrentCreatedPage] = useState(1);

  const { toast } = useToastHelper();
  const { darkTheme } = useDarkTheme();

  const getLogos = useCallback((symbols: string[], token: string) => {
    if (!Array.isArray(symbols) || symbols.some((i) => typeof i !== "string"))
      return;
    //@ts-ignore
    let uniqueSymbols = [...new Set(symbols)];
    if (uniqueSymbols.length > 0) {
      let url = new URL("get_logos", API_URL);
      url.searchParams.append("symbols", uniqueSymbols.toString());
      url.searchParams.append("server", `${CURRENT_BROKER_NAME}.trylevel2.com`);
      const headers = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url.toString(), headers)
        .then((r: any) => {
          var logos_map = new Map();
          for (var item in r.data.data) {
            logos_map.set(item, r.data.data[item]);
          }
          setLogos((p: Map<string, any>) => {
            // @ts-ignore
            return new Map([...p, ...logos_map]);
          });
        })
        .catch((e) => {
          console.error(e);
          // toast.error(e.response.data.detail);
        });
    }
  }, []);

  const onPageChange = (val: number) => {
    setCurrentCreatedPage(val);
    changeCreatedPage(val);
  };
  function get_strategies_by_user(
    token: string,
    user_key: string,
    page: number
  ) {
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    let url2 = new URL("get_published_strategies", API_URL);
    url2.searchParams.append("user_key", user_key);
    url2.searchParams.append("page", page.toString());
    url2.searchParams.append("size", "6");
    axios
      .get(url2.toString(), headers)
      .then((res) => {
        if (res?.data) {
          addCreatedListBadges(res.data.items);
          setCreatedTotalCount(res.data.total);
          setCreatedOffset(res.data.page + 1);
          let symbols =
            res?.data?.items
              ?.map((inst: any) => inst?.strategy?.symbol)
              .filter(Boolean) || [];
          getLogos(symbols, userInfo?.token);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
  const changeCreatedPage = (val: number = currentCreatedPage) => {
    setCurrentCreatedPage(val);
    const user = JSON.parse(localStorage.getItem("user-info")!);
    setUserInfo(user);
    //@ts-ignore
    get_strategies_by_user(user?.token, router?.query?.slug as string, val);
  };

  const addCreatedListBadges = (createdListDataItems: any) => {
    if (createdListDataItems.length) {
      let _createdListDataItems = [...createdListDataItems];
      _createdListDataItems?.map((result: any) => {
        result.badges = result.block_data;
      });
      setCreatedListDataItems(_createdListDataItems);
    } else {
      setCreatedListDataItems([]);
    }
  };

  const getSymbolData = (token: string, symbols: any) => {
    let url = new URL("get_symbols_details", API_URL);
    url.searchParams.append("symbols", symbols);
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url.toString(), headers)
      .then((res) => {
        if (res.statusText == "OK") {
          setSymbolsData(res?.data?.results);
          let symbols =
            res?.data?.results
              ?.map((inst: any) => inst?.ticker)
              .filter(Boolean) || [];
          getLogos(symbols, token);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const getProfileData = useCallback(
    (token: string, userKeyGen?: string) => {
      let url = new URL("get_trader_stats", API_URL);
      url.searchParams.append("user_keygen", userKeyGen || "");
      const headers = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url.toString(), headers)
        .then((res) => {
          if (res?.data) {
            if (res?.data.socials != null) {
              var socials_parse = JSON.parse(res?.data.socials);
              setTwitter(socials_parse["twitter"]);
              setLinkedin(socials_parse["linkedin"]);
            }
            const data = res?.data;
            if (typeof data === "object" && typeof data?.name === "string") {
              let [fName, ...lName] = data.name.split(" ");
              data.first_name = fName;
              data.last_name = lName.join(" ");
            }
            setLast30Data(res?.data?.last_30_trades?.reverse?.());
            setProfileData(res?.data);
            getSymbolData(token, res?.data?.most_traded_symbols || []);

            const perfor = Object.keys(res?.data?.performance).map((key) => ({
              label: key,
              value: res?.data?.performance[key],
            }));
            setPerformance(perfor);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    [router]
  );
  const settings = {
    className: "variable-width",
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 500,
    initialSlide: 0,
    infinite: false,
  };
  useEffect(() => {
    // const user = JSON.parse(localStorage.getItem("user-info")!);
    // user?.user_id && setUserLoading(false);
    // if (!user?.user_id) return;
    // setUserInfo(user);
    //@ts-ignore
    getProfileData("user?.token", router?.query?.slug);
    //@ts-ignore
    get_strategies_by_user("user?.token", router?.query?.slug, 1);
    setUserLoading(false);
  }, [router]);

  // const exportAsImage = async (_?: any) => {
  //   setExportLoader(true);
  //   toJpeg(document.getElementById("main") as any, {
  //     filter: (node) => {
  //       // we don't want to add the minimap and the controls to the image
  //       if (node?.classList?.contains("btn")) {
  //         return false;
  //       }
  //       return true;
  //     },
  //   })
  //     .then(downloadImage)
  //     .catch((err: any) => {
  //       toast.error(err.message || "Error");
  //       setExportLoader(false);
  //       console.error("Error generating Image!", "error", err);
  //     });
  // };

  // const downloadImage = (dataUrl: string) => {
  //   const a = document.createElement("a");
  //   a.setAttribute("download", `${profileData?.name}.jpg`);
  //   a.setAttribute("href", dataUrl);
  //   a.click();
  //   setExportLoader(false);
  // };
  // New export function
  const exportAsImage = async (): Promise<void> => {
    const element = document.getElementById("main") as HTMLElement; // Type assertion for element
    if (!element) {
      throw new Error("Element not found");
    }

    const canvas: HTMLCanvasElement = await html2canvas(element);
    const data: string = canvas.toDataURL("image/jpeg");

    const link: HTMLAnchorElement = document.createElement("a");
    link.href = data;
    link.download = `${profileData?.name}.jpg`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const copyHandler = useCallback((key: string) => {
    const user = JSON.parse(localStorage.getItem("user-info")!);
    let url = new URL("copy_strategy", API_URL);
    url.searchParams.append("user_id", user?.user_id);
    url.searchParams.append("strategy_key", key);
    // url.searchParams.append("challenge", "lsm");
    axios
      .post(
        url.toString(),
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        if (res?.data?.keygen) {
          toast({
            title: t("Strategy copied successfully"),
            variant: "default",
          });
          setTimeout(() => {
            router.push(
              "/edit-strategy/" +
                encodeURIComponent(user?.user_id) +
                "/" +
                res?.data?.id +
                randomString(5) +
                "/" +
                user?.token +
                "/false" +
                `?ref=${router.asPath}&locale=${router.query.locale || "en"}`
            );
          }, 2000);
        } else {
          toast({
            title: t("Error copying strategy"),
            variant: "destructive",
          });
        }
      })
      .catch((e) => {
        toast({
          title: t("Error copying strategy"),
          variant: "destructive",
        });
      });
  }, []);

  const createBadgesFromData = (item: any) => {
    return (
      Object.keys(item?.badges || {}).map((badge: string, index: number) => {
        let color = "";

        switch (badge.toLowerCase()) {
          case "indicators" || "indicator":
            color = "border-indicators text-indicators hover:text-indicators ";
            break;
          case "datas" || "data":
            color = "border-data text-data hover:text-data ";
            break;
          case "patterns":
            color = "border-white text-white hover:text-white ";
            break;
          case "logics":
            color =
              "border-tradingLogic text-tradingLogic hover:text-tradingLogic ";
            break;
          case "actions":
            color = "border-action text-action hover:text-action ";
            break;
          default:
            color = "border-green";
        }
        return item?.badges?.[badge].map((badgeName: string, i: number) => (
          <div className="mr-2" key={index + "-" + i}>
            <Badge variant="outline">{badgeName}</Badge>
          </div>
        ));
      }) || []
    );
  };
  const RadarChartBlock = useCallback(() => {
    const lab: any = [];
    const val: any = [];
    const data: { name: string; value: number }[] = [];
    profileData?.trading_profile_categories?.forEach((element: any) => {
      lab.push(element.category);
      val.push(profileData?.trading_profile_graph?.[element.category] || 0);
      data.push({
        name: element.category,
        value: profileData?.trading_profile_graph?.[element.category] || 0,
      });
    });

    return (
      <Card className="w-full h-80">
        <CardHeader>
          <CardTitle>{t("Trading Profile")}</CardTitle>
        </CardHeader>
        <CardContent className="w-full gap-8 pb-0 pt-0 sm:max-h-96 sm:h-80 flex flex-col sm:flex-row justify-center">
          <div className="w-full h-full">
            <ChartContainer
              config={{
                value: {
                  color: "rgba(72,109,246,1)",
                },
              }}
              className="mx-auto  max-h-[250px]"
            >
              <RadarChart data={data}>
                <ChartTooltip
                  cursor={false}
                  content={
                    <ChartTooltipContent
                      formatter={(value) =>
                        minFixedDecimal(value as number, DP22) + "%"
                      }
                    />
                  }
                />
                <PolarAngleAxis dataKey="name" />
                <PolarGrid />
                <Radar
                  dataKey="value"
                  fill="var(--color-value)"
                  dot
                  fillOpacity={0.6}
                />
              </RadarChart>
            </ChartContainer>
          </div>
        </CardContent>
      </Card>
    );
  }, [profileData, darkTheme]);
  const TotalVolumeGraph = ({
    label,
    values,
    borderColor,
    title,
  }: chartProps) => {
    const data = useMemo(() => {
      return label?.map((item, i) => ({ ts: item, value: values[i] }));
    }, [label, values]);
    const CustomTooltip: TooltipContentType<ValueType, NameType> = ({
      active,
      payload,
      label,
    }) => {
      if (active && payload && payload.length) {
        const value = minFixedDecimal(payload[0].value as number, DP22, "N/A");
        return (
          <div className="flex flex-col gap-2 text-sm bg-background text-foreground border rounded shadow-sm p-2">
            {value !== "N/A" ? "$" : ""}
            {value}
            <div className="">
              {formatEpochDate(label, "DD-MMM-YYYY HH:mm")}
            </div>
          </div>
        );
      }
      return null;
    };
    return (
      <Card className="w-full">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent className="w-full">
          <div className="w-full h-60 max-h-60">
            <ChartContainer
              config={{ value: { color: "#4ade80" } }}
              className="w-full h-full aspect-auto"
            >
              <LineChart accessibilityLayer data={data}>
                <CartesianGrid vertical={false} />
                <XAxis
                  dataKey="ts"
                  tickLine={false}
                  axisLine={false}
                  tickMargin={8}
                  tickFormatter={(value) =>
                    formatEpochDate(value, "DD-MMM-YYYY")
                  }
                />
                <YAxis
                  dataKey="value"
                  tickLine={false}
                  axisLine={false}
                  tickMargin={8}
                  tickFormatter={(value) => "$" + minFixedDecimal(value, DP02)}
                  type="number"
                />
                <ChartTooltip cursor content={CustomTooltip} />
                <Line
                  dataKey="value"
                  type="linear"
                  fill="var(--color-value)"
                  stroke="var(--color-value)"
                  strokeWidth={2}
                  dot={false}
                />
              </LineChart>
            </ChartContainer>
          </div>
        </CardContent>
      </Card>
    );
  };
  const TotalOrderGraph = ({
    label,
    values,
    borderColor,
    title,
  }: chartProps) => {
    const data = useMemo(() => {
      return label?.map((item, i) => ({ ts: item, value: values[i] }));
    }, [label, values]);
    const CustomTooltip: TooltipContentType<ValueType, NameType> = ({
      active,
      payload,
      label,
    }) => {
      if (active && payload && payload.length) {
        const value = payload[0].value;
        return (
          <div className="flex flex-col gap-2 text-sm bg-background text-foreground border rounded shadow-sm p-2">
            {title}: {value}
            <div className="">
              {formatEpochDate(label, "DD-MMM-YYYY HH:mm")}
            </div>
          </div>
        );
      }
      return null;
    };
    return (
      <Card className="w-full">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent className="w-full">
          <div className="w-full h-60 max-h-60">
            <ChartContainer
              config={{ value: { color: borderColor } }}
              className="w-full h-full aspect-auto"
            >
              <LineChart accessibilityLayer data={data}>
                <CartesianGrid vertical={false} />
                <XAxis
                  dataKey="ts"
                  tickLine={false}
                  axisLine={false}
                  tickMargin={8}
                  tickFormatter={(value) =>
                    formatEpochDate(value, "DD-MMM-YYYY")
                  }
                />
                <YAxis
                  dataKey="value"
                  tickLine={false}
                  axisLine={false}
                  tickMargin={8}
                  type="number"
                />
                <ChartTooltip cursor content={CustomTooltip} />
                <Line
                  dataKey="value"
                  type="linear"
                  fill="var(--color-value)"
                  stroke="var(--color-value)"
                  strokeWidth={2}
                  dot={false}
                />
              </LineChart>
            </ChartContainer>
          </div>
        </CardContent>
      </Card>
    );
  };

  const calculateMarkerPosition = (
    current: number,
    lowest: number,
    highest: number
  ) => {
    const range = highest - lowest;
    let position = (current - lowest) / range;
    const percentage = position * 100;
    return percentage.toFixed(2);
  };

  const main = () => {
    const highestReturn =
      typeof profileData?.highest_return === "number"
        ? profileData?.highest_return?.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
        : "NA";
    const lowestReturn =
      typeof profileData?.lowest_return === "number"
        ? profileData?.lowest_return?.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
        : "NA";
    return (
      <>
        <ViewModal
          isOpen={showModal}
          onRequestClose={() => setShowModal(false)}
          selected={selected}
          token={userInfo?.token}
        />
        <div>
          {/* <div className="border border-x-0 py-2">
            <Ticker />
          </div> */}
          <div className={" mx-auto mt-6"}>
            <Card id="main" className="main">
              <CardHeader className="px-6 pb-0">
                <Breadcrumb>
                  <BreadcrumbList>
                    <BreadcrumbItem>
                      <BreadcrumbLink
                        href={`/build?locale=${router.query.locale || "en"}`}
                      >
                        Create
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      <BreadcrumbPage>Profile</BreadcrumbPage>
                    </BreadcrumbItem>
                  </BreadcrumbList>
                </Breadcrumb>
              </CardHeader>
              <CardHeader>
                <CardTitle className="!flex justify-between w-full items-center">
                  <div className="flex gap-3 items-center">
                    {/* <img
                      src={
                        userInfo?.user.profile_image
                          ? userInfo?.user.profile_image
                          : darkTheme
                          ? "/images/logos/Symbol_Dark.png"
                          : "/images/logos/Symbol_Light-30.png"
                      }
                      style={{
                        maxHeight: "30px",
                        maxWidth: "30px",
                      }}
                      alt={"logo"}
                    /> */}
                    <Avatar className="rounded-sm">
                      <AvatarImage
                        src={profileData?.profile_image}
                        id="userImage"
                        alt="userImage"
                      />
                      <AvatarFallback>
                        {getNameInitals(profileData)}
                      </AvatarFallback>
                    </Avatar>
                    {profileData?.name}

                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger>
                          <Dialog>
                            <DialogTrigger asChild>
                              <div className="cursor-pointer">
                                {profileData?.badge == "rock" ? (
                                  <BadgeAlert className="text-[#9B0505]" />
                                ) : profileData?.badge == "bronze" ? (
                                  <BadgeCheck className="text-[#cd7f32]" />
                                ) : profileData?.badge == "silver" ? (
                                  <BadgeCheck className="text-[#19438A]" />
                                ) : profileData?.badge == "gold" ? (
                                  <BadgeCheck className="text-[#FFD700]" />
                                ) : (
                                  ""
                                )}
                              </div>
                            </DialogTrigger>
                            <DialogContent className="sm:max-w-md">
                              <DialogHeader>
                                <DialogTitle>{t("Badges")}</DialogTitle>
                                <DialogDescription>
                                  {t(
                                    "Badges are a quick way to showcase your trading expertise."
                                  )}
                                </DialogDescription>
                              </DialogHeader>
                              <div className="flex items-center space-x-2">
                                <BadgeAlert className="text-[#9B0505]" />
                                <Badge>{t("Incomplete Profile")}</Badge>
                              </div>
                              <div>
                                <p className="text-xs text-muted-foreground">
                                  {t(
                                    "A red badge with an exclamation mark depicts that your profile is currently incomplete and more information needs to be added."
                                  )}
                                </p>
                              </div>
                              <div className="flex items-center space-x-2">
                                <BadgeCheck className="text-[#cd7f32]" />
                                <Badge>{t("Novice Navigator")}</Badge>
                              </div>
                              <div>
                                <p className="text-xs text-muted-foreground">
                                  {t(
                                    "A bronze badge is awarded once you have completed a backtest of at least one strategy and connected Plus100 to your broker API."
                                  )}
                                </p>
                              </div>
                              <div className="flex items-center space-x-2">
                                <BadgeCheck className="text-[#19438A]" />
                                <Badge>{t("Proficient Trader")}</Badge>
                              </div>
                              <div>
                                <p className="text-xs text-muted-foreground">
                                  {t(
                                    "A blue badge is awarded once you have completed a backtest of at least two strategies, deployed at least one strategy for live trading and generated $10+ profit through live deployments."
                                  )}
                                </p>
                              </div>

                              <div className="flex items-center space-x-2">
                                <BadgeCheck className="text-[#FFD700]" />
                                <Badge>{t("Master Strategist")}</Badge>
                              </div>
                              <div>
                                <p className="text-xs text-muted-foreground">
                                  {t(
                                    "A gold badge is awarded once you have deployed at least 5 strategies for live trading, completed a backtest of at least 10 strategies and earned $1000+ profit through live deployments"
                                  )}
                                </p>
                              </div>
                            </DialogContent>
                          </Dialog>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>
                            {profileData?.badge == "rock"
                              ? t("Incomplete Profile")
                              : profileData?.badge == "bronze"
                              ? t("Novice Navigator")
                              : profileData?.badge == "silver"
                              ? t("Proficient Trader")
                              : profileData?.badge == "gold"
                              ? t("Master Strategist")
                              : ""}
                          </p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                  <Button
                    variant={"default"}
                    onClick={() => exportAsImage()}
                    className="flex gap-1 btn"
                    disabled={exportLoader}
                    data-html2canvas-ignore="true"
                  >
                    {t("Export")} {exportLoader ? <Loader /> : ""}
                  </Button>
                </CardTitle>

                <CardDescription>
                  <div className="flex-col">
                    <div>{profileData?.description}</div>

                    {twitter != "" || linkedin != "" ? (
                      <div className="flex mt-3">
                        {linkedin != "" ? (
                          <div className="">
                            <a href={formatUrl(linkedin)} target="_blank">
                              <Image
                                src="/linkedin.png"
                                height={20}
                                width={20}
                                alt="linkedin logo"
                              />
                            </a>
                          </div>
                        ) : (
                          ""
                        )}

                        {twitter != "" ? (
                          <div className="ml-2">
                            <a href={formatUrl(twitter)} target="_blank">
                              <Image
                                src="/twitter.png"
                                height={20}
                                width={20}
                                alt="twitter logo"
                              />
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-2">
                      <span className="text-xs text-muted-foreground">
                        {t("Member since")}{" "}
                        {formatDate(profileData?.member_since, "DD-MMM-YY")}
                      </span>
                    </div>
                  </div>
                </CardDescription>
              </CardHeader>
              <CardContent className="flex flex-col gap-4">
                <Card>
                  <CardHeader>
                    <CardTitle>{t("Performance")}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className=" grid grid-cols-2  md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 w-full gap-4 ">
                      <div>
                        <Card className="p-2 w-full">
                          {/* <div className="text-center text-sm min-h-[40px] flex items-center justify-center"> */}
                          <div className="text-center text-sm min-h-[40px]">
                            {t("Total Strategies")}
                          </div>
                          <div
                            className={cn(
                              "text-center",
                              "text-muted-foreground"
                            )}
                          >
                            {profileData?.total_strategies}
                          </div>
                        </Card>
                      </div>
                      <div>
                        <Card className="p-2 w-full">
                          <div className="text-center text-sm min-h-[40px]">
                            {t("Total Trades")}
                          </div>
                          <div
                            className={cn(
                              "text-center",
                              "text-muted-foreground"
                            )}
                          >
                            {profileData?.total_trades}
                          </div>
                        </Card>
                      </div>
                      <div>
                        <Card className="p-2 w-full">
                          <div className="text-center text-sm min-h-[40px]">
                            {t("Copied Strategies Count")}
                          </div>
                          <div
                            className={cn(
                              "text-center",
                              "text-muted-foreground"
                            )}
                          >
                            {profileData?.copiers_count}
                          </div>
                        </Card>
                      </div>
                    </div>
                    <div className="mt-5 grid grid-cols-2  md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 w-full gap-4 ">
                      {performance?.map((item: any, id: number) => (
                        <Card key={id} className="p-2 w-full">
                          <div
                            className="text-center text-sm min-h-[40px] "
                            key={id}
                          >
                            {item.label}
                          </div>
                          <div
                            className={cn(
                              "text-center",
                              item.value > 0
                                ? "text-green-foreground"
                                : item.value === 0
                                ? "text-muted-foreground"
                                : "text-red-foreground"
                            )}
                          >
                            {item.value > 0 ? "+" : ""}
                            {formatToDecimalPlaces(item.value, 2)}%
                          </div>
                        </Card>
                      ))}
                    </div>
                  </CardContent>
                </Card>
                <div className="flex flex-col lg:flex-row gap-4 h-fit">
                  <MonthlyStrategyPerformance
                    monthlyData={last30Data}
                    t={t}
                    isProfile={true}
                  />
                  <RadarChartBlock />
                </div>
                <div className="flex gap-4 flex-col w-full lg:flex-row">
                  <TotalOrderGraph
                    title={t("Total Orders")}
                    values={profileData?.orders_chart?.map(
                      (item: any) => item.value
                    )}
                    label={profileData?.orders_chart?.map(
                      (item: any) => item.time
                    )}
                    borderColor="#486DF6"
                  />
                  <TotalVolumeGraph
                    title={t("Total Volume (USD)")}
                    values={profileData?.volume_chart?.map(
                      (item: any) => item.value
                    )}
                    label={profileData?.volume_chart?.map(
                      (item: any) => item.time
                    )}
                    borderColor="#4ade80"
                  />
                </div>

                <Card>
                  <CardHeader>
                    <CardTitle>{t("Showcase")}</CardTitle>
                    <CardDescription>
                      {t("Published strategies created by")} {profileData?.name}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    {createdListDataItems.length == 0 ? (
                      <div className="w-full">
                        <div className="flex justify-center">
                          <span className="text-xs text-muted-foreground">
                            {t("No strategies have been made public")}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <ScrollArea className="h-fit">
                          <Table>
                            <TableHeader>
                              <TableRow>
                                <TableHead className="whitespace-nowrap min-w-fit">
                                  {t("Strategy Name")}
                                </TableHead>
                                <TableHead className="whitespace-nowrap min-w-[75px] w-40">
                                  {t("Created at")}
                                </TableHead>
                                <TableHead className="whitespace-nowrap w-36">
                                  {t("Symbol & Timeframe")}
                                </TableHead>
                                <TableHead className="whitespace-wrap w-28">
                                  {t("Backtest Sharpe Ratio")}
                                </TableHead>
                                <TableHead className="whitespace-wrap w-28">
                                  {t("Backtest Cumulative Returns")}
                                </TableHead>
                                <TableHead className="whitespace-wrap w-28">
                                  {t("Backtest Max Drawdown")}
                                </TableHead>
                                <TableHead className="whitespace-nowrap w-32"></TableHead>

                                {/* <TableHead className="whitespace-wrap w-20">
                              {t("Publish")}
                            </TableHead> */}
                              </TableRow>
                            </TableHeader>
                            <TableBody>
                              {createdListDataItems.map(
                                (item: any, index: number) => {
                                  const isDeploy =
                                    item?.is_notification == "1"
                                      ? item?.is_notification_deployed
                                      : item?.is_deployed_live;
                                  // : item?.is_deployed_virtual; // this is actual
                                  const canvasData = JSON.parse(
                                    item?.strategy?.canvas_data
                                  );
                                  const nodes = canvasData?.filter?.(
                                    (item: any) => item.type === "selectorNode"
                                  );
                                  const edges = canvasData?.filter?.(
                                    (item: any) => item.type === "buttonedge"
                                  );
                                  const data =
                                    item?.backtest_data &&
                                    JSON.parse(item?.backtest_data);
                                  const label = data
                                    ? Object.keys(data?.chart)
                                    : null;
                                  const values: number[] | null = data
                                    ? Object.values(data?.chart)
                                    : null;
                                  //@ts-ignore
                                  const isNegativeSum =
                                    toNumberOrNull(
                                      values?.reduce((acc, cur) => acc + cur, 0)
                                    ) < 0;
                                  const sharpRatio =
                                    typeof data?.sr === "number"
                                      ? data?.sr?.toLocaleString("en-US", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                      : "NA";
                                  const DD =
                                    typeof data?.dd === "number"
                                      ? data?.dd?.toLocaleString("en-US", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })
                                      : "NA";
                                  const logo = getValidSymbolImgUrl(
                                    logos.get(item.strategy.symbol as string),
                                    darkTheme
                                  );

                                  const isFxStartegy = getIsFxStrategy(
                                    item?.strategy?.symbol
                                  );

                                  return (
                                    <React.Fragment
                                      key={"createdlistItem-" + index}
                                    >
                                      <TableRow>
                                        <TableCell
                                          className="whitespace-nowrap max-w-[100px]"
                                          onClick={() =>
                                            router.push(
                                              `/strategy_details/${
                                                item.strategy.id
                                              }?locale=${
                                                router.query.locale || "en"
                                              }`
                                            )
                                          }
                                        >
                                          {/* <Link legacyBehavior href={"/strategy_details/" + item.vs_id + `?locale=${router.query.locale || 'en'}`}> */}
                                          <span className="flex flex-row gap-2 justify-between items-center w-full">
                                            <span className="cursor-pointer transition-all duration-500 max-w-full overflow-hidden text-ellipsis">
                                              {item.strategy.strategy_name}
                                            </span>
                                          </span>
                                        </TableCell>
                                        <TableCell className="whitespace-nowrap max-w-[60px]">
                                          {formatEpochDate(
                                            item.epoch_created_at,
                                            "DD-MMM-YY"
                                          )}
                                        </TableCell>
                                        <TableCell className="whitespace-nowrap max-w-[60px]">
                                          {/*{<span>{item.symbol}</span>}*/}
                                          <div className="flex flex-row space-x-2 whitespace-nowrap justify-start items-center dark:opacity-80">
                                            <img
                                              src={logo}
                                              style={{
                                                maxHeight: "30px",
                                                maxWidth: "30px",
                                              }}
                                              alt={item.strategy.symbol}
                                            />
                                            <span>{item.strategy.symbol}</span>
                                            <div className="pl-1">
                                              {item.strategy.timeframe}
                                            </div>
                                          </div>
                                        </TableCell>

                                        {/* <TableCell className="whitespace-nowrap ">
                                      <Badge
                                        className="gap-1"
                                        variant={"outline"}
                                      >
                                        {t("Research")} <MdArrowOutward />
                                      </Badge>
                                    </TableCell> */}

                                        <TableCell
                                          className={cn(
                                            "whitespace-nowrap",
                                            sharpRatio === "NA"
                                              ? "text-muted-foreground"
                                              : sharpRatio > 1.5
                                              ? "text-green-foreground"
                                              : "text-red-foreground"
                                          )}
                                        >
                                          {sharpRatio}
                                        </TableCell>

                                        <TableCell className="whitespace-nowrap ">
                                          {label && values ? (
                                            <ChartComponent
                                              label={label}
                                              values={values}
                                              borderColor={
                                                isNegativeSum
                                                  ? "#E76E50"
                                                  : AccentColor.GREEN
                                              }
                                            />
                                          ) : (
                                            "NA"
                                          )}
                                        </TableCell>
                                        <TableCell
                                          className={cn(
                                            "whitespace-nowrap ",
                                            DD === "NA"
                                              ? "text-muted-foreground"
                                              : DD < 150
                                              ? "text-green-foreground"
                                              : "text-red-foreground "
                                          )}
                                        >
                                          {DD}
                                          {DD !== "NA"}
                                        </TableCell>
                                        {/* <TableCell className="flex justify-center items-center mt-2 text-muted-foreground whitespace-nowrap ">
                                      <FiGlobe />
                                    </TableCell> */}

                                        {/* <TableCell className="whitespace-nowrap max-w-[60px]">
                                          <div>
                                            <div
                                              className={
                                                item.is_deployed_virtual ||
                                                item?.is_deployed_live
                                                  ? "fa fa-trash text-xl cursor-not-allowed"
                                                  : "fa fa-trash text-xl cursor-pointer"
                                              }
                                            ></div>
                                          </div>
                                        </TableCell> */}
                                        <TableCell
                                          className="whitespace-nowrap max-w-fit"
                                          data-html2canvas-ignore="true"
                                        >
                                          <div className="flex gap-2">
                                            <Button
                                              className="cursor-pointer"
                                              variant="ghost"
                                              onClick={() => {
                                                setSelected({
                                                  nodes,
                                                  edges,
                                                  symbol: item.strategy.symbol,
                                                  timeframe:
                                                    item.strategy.timeframe,
                                                });
                                                setShowModal(true);
                                              }}
                                            >
                                              <div className="flex text-muted-foreground w-full items-center gap-2">
                                                <Eye />
                                                <p className="text-xs">
                                                  {t("View")}
                                                </p>
                                              </div>
                                            </Button>
                                            {isFxStartegy ? (
                                              <Button
                                                variant={"secondary"}
                                                className="cursor-pointer"
                                                onClick={() =>
                                                  copyHandler(
                                                    item?.strategy?.keygen
                                                  )
                                                }
                                              >
                                                {t("Copy")}
                                              </Button>
                                            ) : (
                                              <HoverCard>
                                                <HoverCardTrigger>
                                                  <Button
                                                    variant={"secondary"}
                                                    className={cn(
                                                      "cursor-pointer",
                                                      !isFxStartegy
                                                        ? "opacity-30"
                                                        : ""
                                                    )}
                                                  >
                                                    {t("Copy")}
                                                  </Button>
                                                </HoverCardTrigger>
                                                <HoverCardContent className="w-fit">
                                                  {t(
                                                    "This asset class is not currently accessible for your account"
                                                  )}
                                                </HoverCardContent>
                                              </HoverCard>
                                            )}
                                          </div>
                                        </TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell
                                          colSpan={2}
                                          className="max-w-[250px] test-page-slider"
                                        >
                                          <div className="px-4">
                                            <Slider {...settings}>
                                              {createBadgesFromData(item || {})}
                                            </Slider>
                                          </div>
                                        </TableCell>
                                        <TableCell
                                          colSpan={4}
                                          className="max-w-[150px]"
                                        >
                                          {item.strategy.strategy_category
                                            ?.label && (
                                            <Badge variant="secondary">
                                              {
                                                item.strategy.strategy_category
                                                  .label
                                              }
                                            </Badge>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    </React.Fragment>
                                  );
                                }
                              )}
                            </TableBody>
                          </Table>
                          <ScrollBar orientation="horizontal" />
                        </ScrollArea>
                        <Pagination
                          limit={strategiesPerPage}
                          totalCount={createdTotalCount}
                          currentPage={currentCreatedPage}
                          changePage={onPageChange}
                        />
                      </div>
                    )}
                  </CardContent>
                </Card>

                <Card>
                  <CardHeader>
                    <CardTitle>{t("Most Traded Symbols")}</CardTitle>
                    <CardContent className="pt-4">
                      <div className="flex gap-4 flex-wrap w-full">
                        {symbolsData?.map((item: any, index: number) => {
                          if (item.error) return null;
                          return (
                            <Badge
                              key={index}
                              variant="secondary"
                              className="flex gap-2 p-1 px-2 flex-wrap"
                            >
                              {logos?.get(item.ticker as string) !==
                              undefined ? (
                                <>
                                  <img
                                    src={logos?.get(item.ticker as string)}
                                    style={{
                                      maxHeight: "15px",
                                      maxWidth: "15px",
                                    }}
                                    alt={item.ticker}
                                  />
                                </>
                              ) : (
                                <>
                                  <img
                                    src={
                                      darkTheme
                                        ? "/images/logos/Symbol_Dark.png"
                                        : "/images/logos/Symbol_Light-30.png"
                                    }
                                    style={{
                                      maxHeight: "15px",
                                      maxWidth: "15px",
                                    }}
                                    alt={item.ticker}
                                  />
                                </>
                              )}
                              <span className="hidden sm:block">
                                {item.name}
                              </span>
                              <span className="text-muted-foreground">
                                {item.ticker}
                              </span>
                              {(item?.session?.price ||
                                item?.session?.change_percent) && (
                                <div className="!border-[0.5px] h-3 border-muted-foreground" />
                              )}
                              {item?.session?.price && (
                                <span className="text-foreground">
                                  ${toNumberOrNull(item?.session?.price, "--")}
                                </span>
                              )}
                              {item?.session?.change_percent && (
                                <span
                                  className={cn(
                                    "flex items-center ",
                                    item?.session?.change_percent < 0
                                      ? "text-red-foreground"
                                      : "text-green-foreground"
                                  )}
                                >
                                  {item?.session?.change_percent < 0 ? (
                                    <IoMdArrowDropdown size={15} />
                                  ) : (
                                    <IoMdArrowDropup size={15} />
                                  )}
                                  {item?.session?.change_percent?.toFixed(2)}%
                                </span>
                              )}
                            </Badge>
                          );
                        })}
                      </div>
                    </CardContent>
                  </CardHeader>
                </Card>
              </CardContent>
            </Card>
          </div>
        </div>
      </>
    );
  };
  if (userLoading)
    return (
      <div className="fixed h-screen w-screen flex justify-center items-center">
        <Loader text="loading..." />
      </div>
    );
  return (
    <>
      {user ? (
        <Layout meta={<Meta title={t("Profile")} description={t("Profile")} />}>
          {main()}
        </Layout>
      ) : (
        <div className="">
          <Header />
          {main()}
          <Footer darkTheme={darkTheme} />
        </div>
      )}
    </>
  );
};
export const getServerSideProps: GetServerSideProps = async ({
  query,
  locale,
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "en", [
        "leaderboard",
        "layout",
        "test",
        "build",
      ])),
    },
  };
};
export default Profile;
